<template>
  <v-ons-page>

    <v-ons-toolbar>
      <div class="left">
        <v-ons-back-button v-if="! $md"></v-ons-back-button>
        <v-ons-toolbar-button v-else @click="pageStack.pop()">
          <v-ons-icon icon="md-arrow-left" size="24px"></v-ons-icon>
        </v-ons-toolbar-button>
      </div>
      <div class="center">{{ isEdit ? 'Éditer la fiche culture' : 'Ajouter une culture' }}</div>
      <div class="right">
        <v-ons-toolbar-button v-if="isEdit" @click="deleteCultureConfirm">
          <v-ons-progress-circular v-if="isSubmitDelete" :modifier="$mdModifier" indeterminate></v-ons-progress-circular>
          <v-ons-icon v-else icon="trash"></v-ons-icon>
        </v-ons-toolbar-button>
      </div>
    </v-ons-toolbar>

    <div class="content">

      <app-error-msg :list="errorMsgList"></app-error-msg>

      <v-ons-list modifier="noborder perflist">

        <template v-if="! isEdit">

          <app-label input-id="inputCult" label="Culture" :error-msg-list="errorMsgList"></app-label>
          <v-ons-list-item modifier="nodivider input">
            <div class="center">
              <v-ons-select :modifier="culture.ref_culture ? 'underbar' : 'underbar placeholder'"
                            v-model="culture.ref_culture" ref="inputCult">
                <option value="" hidden>Choisissez la culture</option>
                <optgroup label="Cultures principales">
                  <option v-for="(cult, refCult) in referentiel.cultures" :key="refCult" :value="refCult"
                          v-if="cult.is_principal">
                    {{ cult.libelle }}
                  </option>
                </optgroup>
                <optgroup label="Cultures secondaires">
                  <option v-for="(cult, refCult) in referentiel.cultures" :key="refCult" :value="refCult"
                          v-if="! cult.is_principal">
                    {{ cult.libelle }}
                  </option>
                </optgroup>
              </v-ons-select>
            </div>
          </v-ons-list-item>

          <app-label input-id="inputDest" label="Destination" :error-msg-list="errorMsgList"></app-label>
          <v-ons-list-item modifier="nodivider input">
            <div class="center">
              <v-ons-select :modifier="culture.ref_destination ? 'underbar' : 'underbar placeholder'"
                            v-model="culture.ref_destination" ref="inputDest">
                <option value="" hidden>Choisissez la destination</option>
                <option v-for="refDest in culture.ref_culture ? Object.keys(referentiel.cultures[culture.ref_culture].destinations) : Object.keys(referentiel.libelles.destinations)"
                        :key="refDest" :value="refDest">
                  {{ referentiel.libelles.destinations[refDest] }}
                </option>
              </v-ons-select>
            </div>
          </v-ons-list-item>

          <v-ons-list-item modifier="nodivider perfswitch">
            <label class="center">
              Culture bio
            </label>
            <div class="right">
              <v-ons-switch :modifier="$mdModifier" v-model="culture.is_bio"></v-ons-switch>
            </div>
          </v-ons-list-item>

        </template>

        <template v-else>

          <app-label input-id="inputSurf" label="Surface (ha)" :error-msg-list="errorMsgList"></app-label>
          <app-input input-id="inputSurf" ref="inputSurf" input-type="number" v-model.number="culture.surface"
                    placeholder="Entrez la surface en ha" input-step="0.01"></app-input>

          <app-label input-id="inputRdt" label="Rendement (q/ha)" :error-msg-list="errorMsgList"></app-label>
          <app-input input-id="inputRdt" ref="inputRdt" input-type="number" v-model.number="rendementVal"
                      placeholder="Entrez le rendement en q/ha" input-step="0.1"></app-input>

        </template>

      </v-ons-list>


      <footer class="footer--perfbutton">
        <v-ons-button modifier="large--cta perflarge" @click="saveCulture">
          {{ isEdit ? 'Enregistrer' : 'Ajouter la culture' }}
          <v-ons-progress-circular v-if="isSubmit" :modifier="$mdModifier" indeterminate></v-ons-progress-circular>
        </v-ons-button>
      </footer>


    </div>

  </v-ons-page>
</template>

<script>
import mixinsCommons from '../mixins/commons.js';

import { store } from '../store.js';

import AppErrorMsg from '../partials/ErrorMsg.vue';
import AppLabel from '../partials/Label.vue';
import AppInput from '../partials/Input.vue';

export default {
  mixins: [mixinsCommons],
  components: { AppErrorMsg, AppLabel, AppInput },
  props: ['pageStack'],
  data() {
    return {
      culture: {
        ref_culture: '',
        ref_destination: '',
        surface: '',
        rendement: '',
        is_bio: false
      },
      rendementVal: '',
      indexCulture: -1,
      state: store.state,
      data: store.data
    };
  },
  computed: {
    user() {
      return this.state.user;
    },
    campagne() {
      return this.user.campagne;
    },
    referentiel() {
      return this.data.referentiel;
    },
    isEdit() {
      return this.indexCulture != -1;
    }
  },
  watch: {
    'culture.ref_culture'(value) {
      if (value) {
        if (!this.referentiel.cultures[value].destinations[this.culture.ref_destination]) {
          this.culture.ref_destination = '';
        }
      }
    },
    rendementVal(value, oldValue) {
      if (oldValue === '' && this.culture.rendement) {
        // from created ==>> RAF
      } else if (value === 0) {
        // Poids net de la récolte max : 1/1000 t ~ 0t
        // Surface max : 100 ha
        // r = 1/1000 t / 100 ha = 0.00001
        this.culture.rendement = 0.00001;
      } else {
        // rendementVal ==>> q/ha
        this.culture.rendement = Math.round(value / 10 *100000)/100000;
      }
    }
  },
  methods: {
    async saveCulture() {
      if (this.isSubmit) {
        return;
      }
      this.resetErrorMsgList();

      if (!this.culture.ref_culture) {
        this.setErrorMsgList('inputCult', "La culture est obligatoire");
      }

      if (!this.culture.ref_destination) {
        this.setErrorMsgList('inputDest', "La destination est obligatoire");
      }

      if (this.isEdit) {
        if (!this.culture.surface) {
          this.setErrorMsgList('inputSurf', "La surface est obligatoire");
        }

        if (!this.culture.rendement) {
          this.setErrorMsgList('inputRdt', "Le rendement est obligatoire");
        }
      }

      if (Object.keys(this.errorMsgList).length) {
        this.$scrollTop();
        return;
      }

      this.isSubmit = true;

      const body = {
        id: this.user.id,
        date: this.user.date,
        data: this.culture
      };
      if (this.isEdit) {
        body.index_culture = this.indexCulture;
      }

      const fetchInit = this.$getFetchInit();
      fetchInit.body = JSON.stringify(body);
      const callPath = this.$apiDomain + this.getPath('/culture');
      try {
        const response = await this.handleRequest(callPath, fetchInit);

        this.updateUserFromResponse(response.user);

        this.pageStack.length > 1 && this.pageStack.pop();
        if (! this.isEdit) {
        this.pageStack.length > 1 && this.pageStack.pop();
        }
      } catch(error) {
          this.handleError(error);
      }
    },
    deleteCultureConfirm() {
      this.$ons.notification.confirm({
        modifier: this.$mdModifier,
        title: 'Attention !',
        message: "Êtes-vous sûr de vouloir vous supprimer cette culture ?",
        buttonLabels: ['Annuler', 'Supprimer'],
        cancelable: true,
        callback: function (index) {
          if (index === 1) { // -1 if canceled
            this.deleteCulture();
          }
        }.bind(this)
      });
    },
    async deleteCulture() {
      this.isSubmitDelete = true;
      const fetchInit = this.$getFetchInit('DELETE');
      fetchInit.body = JSON.stringify({
        id: this.user.id,
        date: this.user.date,
        index_culture: this.indexCulture
      });
      const callPath = this.$apiDomain + this.getPath('/culture');
      try {
        const response = await this.handleRequest(callPath, fetchInit);

        this.updateUserFromResponse(response.user);
        
        this.pageStack.length > 1 && this.pageStack.pop();
      } catch(error) {
          this.handleError(error, 'de la suppression');
      }
    }
  },
  created() {
    if (this.isEdit) {
      this.setJson(this.culture, this.user.cultures[this.indexCulture]);
      if (this.culture.surface < 0.0001) {
        this.culture.surface = '';
        this.culture.rendement = '';
      } else if (this.culture.rendement < 0.0001) {
        this.rendementVal = 0;
      } else if (this.culture.rendement) {
        // rendementVal ==>> q/ha
        this.rendementVal = Math.round(this.culture.rendement * 10 *100000)/100000;
      }
    }
  }
}
</script>
